import { useGlobalStore } from "@/store/GlobalStore";
import {
  Checkbox,
  Form,
  Input,
  InputNumber,
  Radio,
  Slider,
  Select,
  Drawer,
  Button,
} from "@renderbus/ui";

import { FormInstance } from "antd/es/form/Form";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import request from "project-config/services/request/request";
import { ProjectTransfer } from "../transfer-container";
import { useProjectStore } from "../../store/project-store";

import { IProjectForm, Project, TransferPropsType } from "../../types";
import { ProjectModalStyle, DrawerFooter } from "./atom.js";

export enum ParamsType {
  RenderNum = "renderNum",
  TaskOverTime = "taskOverTime",
  MunuTaskOverTime = "munuTaskOverTime",
}

enum ProjectMemberType {
  OriginType = "OriginType",
  DingTalkType = "DingTalkType",
}

const AddOrEditProjectModal: React.FC<{
  operationType: Project.OperationType;
  open?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
  transferProps: TransferPropsType;
  row?: Project.Info;
  projectForm: FormInstance<IProjectForm>;
  params: { renderNum: number; taskOverTime: number; munuTaskOverTime: number };
  setParams: (params: any) => void;
}> = ({
  operationType,
  open = false,
  onCancel,
  onOk,
  transferProps,
  row,
  projectForm,
  params,
  setParams,
}) => {
  const initTransferData = [...transferProps.dataSource];
  const {
    isDomestic,
    isPersonal,
    isCertified,
    isSubAccount,
    userInfo,
    isDingTalkLeader,
  } = useGlobalStore();
  const { t } = useTranslation("center");
  const [checkedList, setCheckedList] = useState<string[]>([]);
  const [openStatus, setOpenStatus] = useState(false);
  const {
    subDingtalkDatas,
    setSubDingtalkDatas,
    setOriginDingTalkData,
    // sumbitLoading,
  } = useProjectStore();
  const [isShowMemberSelect, setIsShowMemberSelect] = useState(
    !isDingTalkLeader
  );
  const [currentSelectType, setCurrentSelectType] = useState(
    ProjectMemberType.OriginType
  );
  const initParams = {
    renderNum: 1,
    taskOverTime: 12,
    munuTaskOverTime: 24,
  };
  const requiredInputTip = t("user_com_childPro_name_empty");
  const onValueChange = (val: any, key: string) => {
    setParams({
      ...params,
      [key]: typeof val === "object" ? val.target.value : val,
    });
  };
  const onCheckedChange = (value: any) => {
    setCheckedList(value);
  };
  const getDisabledState = (key: string) => !checkedList.includes(key);
  const handleKeyUp = (e: any, min: number, max: number, key: string) => {
    const val = e.target.value;
    if (val > max) {
      e.target.value = max;
    } else if (val < min) {
      e.target.value = min;
    }
    // onValueChange(e, key);
  };
  const handleKeyPress = (e: any) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode === 46 && e.target.value.indexOf(".") !== -1) {
      // 已经有一个小数点，则禁止输入
      e.preventDefault();
    } else if (
      charCode !== 46 &&
      charCode !== 8 &&
      (charCode < 48 || charCode > 57)
    ) {
      // 不是小数点、Backspace键，且不是数字，则禁止输入
      e.preventDefault();
    }
  };

  const checkBoxPropsItems = [
    {
      key: ParamsType.RenderNum,
      label: t("user_com_childPro_name_label_params_lock_0"),
      baseProps: {
        defaultValue: initParams.renderNum,
        className: "background-2C2C31",
        value: params.renderNum,
        disabled: getDisabledState(ParamsType.RenderNum),
        onChange: (val: any) => onValueChange(val, ParamsType.RenderNum),
      },
      numProps: {
        precision: 0,
        // 临界值限制输入
        formatter: (val: any) => (val > 99 ? 99 : val < 1 ? 1 : val),
        parser: (val: any) => val,
        onKeyUp: (e: any) => handleKeyUp(e, 1, 99, ParamsType.RenderNum),
        onKeyPress: handleKeyPress,
      },
      sliderProps: {
        min: 1,
        max: 99,
      },
    },
    {
      key: ParamsType.TaskOverTime,
      label: t("user_com_childPro_name_label_params_lock_1"),

      baseProps: {
        defaultValue: initParams.taskOverTime,
        className: "background-2C2C31",
        value: params.taskOverTime,
        onChange: (val: any) => onValueChange(val, ParamsType.TaskOverTime),
        disabled: getDisabledState(ParamsType.TaskOverTime),
      },
      numProps: {
        precision: 2,
        step: 0.01,
        formatter: (val: any) => (val > 72 ? 72 : val < 0 ? 0 : val),
        parser: (val: any) => val,
        onKeyUp: (e: any) => handleKeyUp(e, 0, 72, ParamsType.TaskOverTime),
        onKeyPress: handleKeyPress,
      },
      sliderProps: {
        min: 0,
        max: 72,
      },
    },
    {
      key: ParamsType.MunuTaskOverTime,
      label: t("user_com_childPro_name_label_params_lock_2"),
      baseProps: {
        defaultValue: initParams.munuTaskOverTime,
        className: "background-2C2C31",
        value: params.munuTaskOverTime,
        onChange: (val: any) => onValueChange(val, ParamsType.MunuTaskOverTime),
        disabled: getDisabledState(ParamsType.MunuTaskOverTime),
      },
      numProps: {
        precision: 2,
        step: 0.01,
        formatter: (val: any) => (val > 72 ? 72 : val < 0 ? 0 : val),
        parser: (val: any) => val,
        onKeyUp: (e: any) => handleKeyUp(e, 0, 72, ParamsType.MunuTaskOverTime),
        onKeyPress: handleKeyPress,
      },
      sliderProps: {
        min: 0,
        max: 72,
      },
    },
  ];
  const getEditData = () => {
    const checkedList = [];
    row?.munuTaskOverTimeStatus &&
      checkedList.push(ParamsType.MunuTaskOverTime);
    row?.renderNumStatus && checkedList.push(ParamsType.RenderNum);
    row?.taskOverTimeStatus && checkedList.push(ParamsType.TaskOverTime);
    checkedList.map((key) => {
      setParams((params: any) => ({
        ...params,
        [key]:
          key === "renderNum" ? (row as any)[key] : (row as any)[key] / 3600,
      }));
      return key;
    });
    setCheckedList(checkedList);
    projectForm.setFieldValue("paramsLocked", checkedList);
  };
  // 查询是否存在钉钉子账号
  const getIsExistDingTalkOriganize = async () => {
    if (
      !isSubAccount &&
      isDomestic &&
      isCertified &&
      !(isCertified && isPersonal)
    ) {
      const { data } = await request.post(
        "/api/rendering/user/queryDingTalkAppSettings",
        {}
      );
      setCurrentSelectType(
        data?.appKey
          ? ProjectMemberType.DingTalkType
          : ProjectMemberType.OriginType
      );
      setIsShowMemberSelect(!!data?.appKey);
      if (!data?.appKey) return;
    } else if (isDingTalkLeader) {
      setCurrentSelectType(ProjectMemberType.DingTalkType);
      setIsShowMemberSelect(false);
    } else {
      setCurrentSelectType(ProjectMemberType.OriginType);
      setIsShowMemberSelect(false);
      return;
    }
    if (operationType === Project.OperationType.EDIT) return;
    const { data: result } = await request.post(
      "/api/rendering/user/queryDingTalkDeptByUser"
    );
    setSubDingtalkDatas(result ?? []);
    setOriginDingTalkData(result ?? []);
  };
  const isProjectLockedOpen = !!userInfo?.projectLocked;
  useEffect(() => {
    if (operationType === Project.OperationType.EDIT) {
      setOpenStatus(true);
      getEditData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operationType, row, open]);

  useEffect(() => {
    if (open) {
      projectForm.setFieldsValue({
        newName: row?.projectName,
        status: row?.status,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (!open) return;
    getIsExistDingTalkOriganize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  function resetNewName(e: any) {
    projectForm.setFieldValue("newName", e.target.value);
  }

  return (
    <Fragment>
      <ProjectModalStyle />
      <Drawer
        destroyOnClose
        width={560}
        open={open}
        onClose={onCancel}
        title={t(`user_com_childPro_${operationType}_dialog_title`)}
        footer={
          <DrawerFooter>
            <Button type="default" onClick={onCancel}>
              {t("common_store_global_dialog_default_cancel")}
            </Button>
            <Button type="primary" onClick={onOk}>
              {t(`user_com_childPro_dialog_confirm_${operationType}`)}
            </Button>
          </DrawerFooter>
        }
        drawerContent={
          <>
            <Form
              className="project-manage-form"
              size="large"
              colon={false}
              requiredMark={false}
              form={projectForm}
              labelAlign="right"
              layout="vertical"
            >
              <Form.Item
                name="newName"
                label={t("user_com_childPro_name_place")}
                rules={[
                  {
                    required: true,
                    message: requiredInputTip,
                    pattern: /^.*\S+.*$/,
                  },
                ]}
              >
                <Input
                  className="background-2C2C31"
                  placeholder={t("user_com_childPro_name_place")}
                  onChange={resetNewName}
                  maxLength={50}
                  disabled={
                    operationType === Project.OperationType.EDIT &&
                    (userInfo?.accountType === 1
                      ? false
                      : row?.userId !== userInfo?.userId)
                  }
                />
              </Form.Item>
              {operationType === Project.OperationType.ADD && (
                <Form.Item
                  name="status"
                  label={t("user_com_childPro_head_label_operate_status")}
                  initialValue={1}
                >
                  <Radio.Group onChange={(e) => setOpenStatus(!e.target.value)}>
                    <Radio value={0} key="open">
                      {t("user_com_childPro_head_label_operate_status_1")}
                    </Radio>
                    <Radio value={1} key="close">
                      {t("user_com_childPro_head_label_operate_status_0")}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              )}

              {openStatus && (
                <>
                  {(!isSubAccount || isDingTalkLeader) && (
                    <Form.Item
                      label={
                        <div>
                          <span>
                            {t("user_com_childPro_head_label_member")}
                          </span>
                          {isShowMemberSelect && (
                            <Select
                              getPopupContainer={() => document.body}
                              className="project-transfer-select"
                              popupClassName="project-popup-select"
                              allowClear={false}
                              options={[
                                {
                                  value: ProjectMemberType.DingTalkType,
                                  label: t(
                                    "user_com_childManage_dingtalk_sub_account"
                                  ),
                                },
                                {
                                  value: ProjectMemberType.OriginType,
                                  label: t("user_com_childManage_sub_account"),
                                },
                              ]}
                              defaultValue={ProjectMemberType.DingTalkType}
                              size="small"
                              onChange={(val) => setCurrentSelectType(val)}
                            />
                          )}
                        </div>
                      }
                    >
                      <ProjectTransfer
                        isDingTalkOriganize={
                          currentSelectType === ProjectMemberType.DingTalkType
                        }
                        dingTalkDataSource={subDingtalkDatas}
                        transferProps={Object.assign({}, transferProps, {
                          dataSource:
                            currentSelectType === ProjectMemberType.DingTalkType
                              ? []
                              : initTransferData,
                        })}
                      />
                    </Form.Item>
                  )}
                  {isProjectLockedOpen && (
                    <Form.Item
                      name="paramsLocked"
                      label={
                        <div>
                          <div className="params-locked-title">
                            {t("user_com_childPro_name_label_params_lock")}
                          </div>
                          <div className="params-locked-tip">
                            {t("user_com_childPro_name_label_params_lock_tip")}
                          </div>
                        </div>
                      }
                    >
                      <Checkbox.Group
                        value={checkedList}
                        onChange={onCheckedChange}
                      >
                        {checkBoxPropsItems.map((item) => (
                          <div key={item.key} className="checkBox-item">
                            <Checkbox value={item.key}>{item.label}</Checkbox>
                            <InputNumber
                              {...item.baseProps}
                              {...item.numProps}
                              controls={false}
                            />
                            <Slider {...item.baseProps} {...item.sliderProps} />
                          </div>
                        ))}
                      </Checkbox.Group>
                    </Form.Item>
                  )}
                </>
              )}
            </Form>
          </>
        }
      ></Drawer>
      {/* <Modal
        afterClose={() => {
          setParams(initParams);
          setCheckedList([]);
          setOpenStatus(false);
        }}
        okButtonProps={{ loading: sumbitLoading }}
        destroyOnClose
        open={open}
        onCancel={onCancel}
        onOk={onOk}
        okText={t(`user_com_childPro_dialog_confirm_${operationType}`)}
        title={t(`user_com_childPro_${operationType}_dialog_title`)}
        children={}
      /> */}
    </Fragment>
  );
};
export default AddOrEditProjectModal;
